export default Object.freeze({
  Text: 1,
  Markdown: 2,
  AdaptiveCard: 3,
});
